<template>
  <div v-if="editable">
    <v-select
      v-if="useVuetify"
      v-model="selectedId"
      @update:model-value="do_change"
      :label="placeholder"
      :placeholder="placeholder"
      :items="selectOptions"
      :multiple="multi"
      :density="vuetifyDensity"
      hide-details="auto"
      variant="outlined"
      clearable
    ></v-select>
    <el-select
      v-else
      v-model="selectedId"
      @change="do_change"
      :placeholder="placeholder"
      :size="size"
      :filterable="true"
      :multiple="multi"
    >
      <el-option
        v-if="allowAll && !multi"
        :value="0"
        :label="'Any Category'"
      ></el-option>
      <el-option
        v-for="option in getLeadCategories"
        :value="option.id"
        :key="option.id"
        :label="option.label"
      >
      </el-option>
    </el-select>
  </div>
  <div v-else>
    <span>
      {{ getSelectedLabel() }}
    </span>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'leadCategorySelect',
  computed: {
    ...mapGetters('leadCategory', ['getLeadCategories']),
    selectOptions() {
      const options = this.getLeadCategories.map((category) => ({
        value: category.id,
        title: category.label,
      }));

      if (this.allowAll && !this.multi) {
        options.unshift({ value: 0, title: 'Any Category' });
      }

      return options;
    },
    vuetifyDensity() {
      const densityMap = {
        default: 'default',
        small: 'compact',
        mini: 'comfortable',
      };
      return densityMap[this.size] || 'compact';
    },
  },
  props: {
    value: {
      type: [Number, String],
    },
    initialId: {
      type: [Number, Array],
      required: false,
    },
    size: {
      type: String,
      default: () => {
        return 'small';
      },
    },
    placeholder: {
      type: String,
      required: false,
      default: () => {
        return 'Select a Lead Category';
      },
    },
    editable: {
      type: Boolean,
      required: false,
      default: true,
    },
    allowAll: {
      type: Boolean,
      required: false,
      default: false,
    },
    multi: {
      type: Boolean,
      required: false,
      default: () => {
        return false;
      },
    },
    useVuetify: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      selectedId: undefined,
    };
  },
  watch: {
    initialId(id) {
      this.selectedId = id;
    },
    value(n) {
      this.selectedId = parseInt(n);
    },
  },
  async created() {
    if (this.initialId) {
      this.selectedId = this.initialId;
    }
    if (this.value != undefined) {
      this.selectedId = parseInt(this.value);
    }
  },
  methods: {
    do_change() {
      // Multi will always be an array or undefined
      if (this.multi) {
        this.$emit('update:leadCategory', this.selectedId);
        return;
      }

      // Single varies based on valid values
      const leadCategory = this.getLeadCategories.find(
        (c) => c.id == this.selectedId
      );
      if (leadCategory) {
        this.$emit('update:leadCategory', leadCategory);
        this.$emit('update:modelValue', leadCategory);
        this.$emit('change', leadCategory.id);
      } else {
        // Because we parse from a string at times 0 instead of undefined
        this.$emit('update:leadCategory', undefined);
        this.$emit('update:modelValue', 0);
        this.$emit('change', 0);
      }
    },
    getSelectedLabel() {
      const lc = this.getLeadCategories.find((c) => c.id == this.selectedId);
      return lc ? lc.label : 'None';
    },
  },
};
</script>
